"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedView = void 0;
function embedView() {
    var isEmbed = false;
    var embedView = document.querySelector('.js-embed-view');
    if (!embedView) {
        return;
    }
    if (window === window.top) {
        showReader();
        console.log('is top window');
        return;
    }
    console.log('is NOT top window');
    // embedView.classList.add('d-none');
    var height;
    var postFrameHeight = function () {
        if (height === embedView.offsetHeight) {
            return;
        }
        // console.log('sending message: parent <- child');
        height = embedView.offsetHeight;
        window.parent.postMessage({
            frameHeight: height
        }, '*');
    };
    var sendPostMessage = function () {
        postFrameHeight();
    };
    window.onload = sendPostMessage;
    window.onresize = sendPostMessage;
    window.addEventListener('message', function (e) {
        isEmbed = e.data.isEmbed;
        if (!isEmbed) {
            return;
        }
        var locale = e.data.locale;
        hideScrollbar(embedView);
        embedViewArticleAbstract(embedView, locale);
        embedViewArticleRead(embedView, locale);
    }, false);
}
exports.embedView = embedView;
function embedViewArticleAbstract(embedView, locale) {
    var _a, _b, _c, _d, _e;
    var container = document.querySelector('#articles-abstract');
    if (!container) {
        return;
    }
    setUrlParamApiLanguage(locale);
    (_a = document.querySelector('body header')) === null || _a === void 0 ? void 0 : _a.remove();
    (_b = document.querySelector('body footer')) === null || _b === void 0 ? void 0 : _b.remove();
    removeCookieBar();
    container.classList.replace('container', 'container-fluid');
    (_c = document.querySelector('.btn-add-to-library')) === null || _c === void 0 ? void 0 : _c.remove();
    // Topics
    (_d = document.querySelector('.topic-abstract-first')) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
    (_e = document.querySelector('.topic-abstract-last')) === null || _e === void 0 ? void 0 : _e.classList.remove('d-none');
    // embedView.classList.remove('d-none');
}
function embedViewArticleRead(embedView, locale) {
    var container = document.querySelector('#articles-read');
    if (!container) {
        return;
    }
    setUrlParamApiLanguage(locale);
    removeCookieBar();
}
function removeCookieBar() {
    var _a;
    (_a = document.querySelector('#cookie-bar')) === null || _a === void 0 ? void 0 : _a.remove();
}
function hideScrollbar(embedView) {
    // const userAgent = navigator.userAgent.toLowerCase();
    // if (userAgent.indexOf('safari') === -1) {
    //     return;
    // }
    var scrollbarCss = "::-webkit-scrollbar { width: 0; }";
    var style = document.createElement('style');
    style.append(document.createTextNode(scrollbarCss));
    document.head.append(style);
}
function setUrlParamApiLanguage(newLocale) {
    var hasFeature = 'URLSearchParams' in window;
    if (!hasFeature) {
        return;
    }
    var params = new URLSearchParams(window.location.search);
    var apiLanguageKey = 'api_language';
    var apiLanguage = params.get(apiLanguageKey);
    var isValidLanguage = apiLanguage !== null && apiLanguage.length === 2;
    console.log(apiLanguage, apiLanguage === null || apiLanguage === void 0 ? void 0 : apiLanguage.length);
    if (isValidLanguage) {
        showReader();
        return;
    }
    params.set(apiLanguageKey, newLocale);
    window.location.replace("".concat(location.origin).concat(location.pathname, "?").concat(params));
}
function showReader() {
    var _a;
    var hideReaderClass = 'hide-reader';
    if (!document.body.classList.contains(hideReaderClass)) {
        return;
    }
    (_a = document.body.querySelector('.load-placeholder')) === null || _a === void 0 ? void 0 : _a.remove();
    document.body.classList.remove(hideReaderClass);
    console.log('show reader content');
}
